import React, { useEffect } from "react"
import { ProposalPreviewModalProps } from "../../common/types/proposal"
import ProposalPreviewModal from "../../common/proposal/previewmodal.component"
import { useDispatch, useSelector } from "react-redux"
import { ProposalSelector } from "../../state/proposal/selectors"
import { ProposalAction } from "../../state/proposal/actions"

export const ProposalPreviewModalWrapper = (props: ProposalPreviewModalProps) => {
    const proposal = useSelector(ProposalSelector.get)
    const dispatch = useDispatch()

    useEffect(() => {
        if (!proposal.isLoading && !proposal.isLoaded) {
            dispatch(ProposalAction.fetch(props.proposalHash))
        }
    }, [])

    return (
        <ProposalPreviewModal
            proposalType={props.proposalType}
            onClose={props.onCloseCallback}
            pdfLink={proposal?.variables.document.pdfUri ?? ""}
            hash={props.proposalHash}
            publicLink={proposal?.publicLink ?? ""}
        />
    )
}


// WEBPACK FOOTER //
// ./src/proposal/modals/ProposalPreviewModal.tsx